import React from 'react';
import { View, TouchableOpacity, TextInput } from 'react-native';
import { useTheme } from 'react-native-paper';
import { QText } from './index';

const NumericStepper = ({
  value,
  onChangeText,
  onIncrement,
  onDecrement,
  error,
  errorText,
  helperText,
  label,
  maxLength = 3,
  style,
  ...props
}) => {
  const theme = useTheme();

  const styles = {
    container: {
      marginBottom: 16,
    },
    label: {
      fontSize: 13,
      color: theme.colors.text,
      marginBottom: 8,
      fontWeight: '500',
    },
    wrapper: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      maxWidth: 600,
      alignSelf: 'center',
    },
    button: {
      width: 48,
      height: 48,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: theme.colors.primary,
      borderRadius: 8,
      cursor: 'pointer',
      zIndex: 1,
    },
    buttonText: {
      fontSize: 18,
      color: theme.colors.whiteTxt,
      fontWeight: '600',
      lineHeight: 20,
      textAlign: 'center',
      includeFontPadding: false,
      textAlignVertical: 'center',
      userSelect: 'none',
      pointerEvents: 'none',
    },
    inputContainer: {
      backgroundColor: theme.colors.onBackground,
      borderWidth: 1,
      borderColor: error ? theme.colors.error : theme.colors.borderColor,
      borderRadius: 8,
      paddingHorizontal: 24,
      paddingVertical: 12,
      marginHorizontal: 16,
      alignItems: 'center',
      justifyContent: 'center',
      flex: 1,
    },
    input: {
      fontSize: 16,
      color: theme.colors.secondaryText,
      fontWeight: '600',
      textAlign: 'center',
      padding: 0,
      borderWidth: 0,
      outlineStyle: 'none',
      backgroundColor: 'transparent',
      minWidth: 40,
    },
    errorText: {
      color: theme.colors.error,
      fontSize: 12,
      marginTop: 4,
      textAlign: 'center',
    },
    helperText: {
      fontSize: 12,
      color: theme.colors.secondary,
      marginTop: 4,
      textAlign: 'center',
    },
  };

  return (
    <View style={[styles.container, style]}>
      {label && <QText style={styles.label}>{label}</QText>}
      <View style={styles.wrapper}>
        <TouchableOpacity
          onPress={onDecrement}
          style={styles.button}
          activeOpacity={0.7}
          hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
        >
          <QText style={styles.buttonText}>-</QText>
        </TouchableOpacity>

        <View style={styles.inputContainer}>
          <TextInput
            value={value}
            onChangeText={onChangeText}
            keyboardType="number-pad"
            style={styles.input}
            selectionColor={theme.colors.primary}
            cursorColor={theme.colors.primary}
            maxLength={maxLength}
            {...props}
          />
        </View>

        <TouchableOpacity
          onPress={onIncrement}
          style={styles.button}
          activeOpacity={0.7}
          hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
        >
          <QText style={styles.buttonText}>+</QText>
        </TouchableOpacity>
      </View>
      {error && errorText && (
        <QText style={styles.errorText}>{errorText}</QText>
      )}
      {helperText && <QText style={styles.helperText}>{helperText}</QText>}
    </View>
  );
};

export default NumericStepper;
